// extracted by mini-css-extract-plugin
export default {"Container":"Goals_Container__WcqBP"};